import AlgoliaInsights from 'search-insights';

export function useAlgolia() {
  const {
    public: { algoliaIndex, algoliaAppId, algoliaSearchKey }
  } = useRuntimeConfig();
  const { userData } = useAuth();
  const userId = userData.value?.id;

  const mountAlgoliaInsights = () => {
    AlgoliaInsights("init", {
      appId: algoliaAppId,
      apiKey: algoliaSearchKey,
      authenticatedUserToken: userId,
    });
  }

  const algoliaProductClickedEvent = (objectIDs: string[]) =>{
    AlgoliaInsights("clickedObjectIDs", {
      userToken: userId,
      authenticatedUserToken: userId,
      eventName: "Product Clicked",
      index: algoliaIndex,
      objectIDs: objectIDs,
    });
  }

  const algoliaProductClickedEventAfterSearch = (positions: number[], objectIDs: string[], hit: Hit<BaseHit>) => {
    AlgoliaInsights("clickedObjectIDsAfterSearch", {
      userToken: userId,
      authenticatedUserToken: userId,
      eventName: "Product Clicked",
      index: algoliaIndex,
      queryID: hit.__queryID,
      objectIDs: objectIDs,
      positions: positions,
    });
  }

  const algoliaAddToCart = (objectIDs: string[])=> {
    AlgoliaInsights("addedToCartObjectIDs", {
      userToken: userId,
      authenticatedUserToken: userId,
      eventName: "Add To Bag",
      index: algoliaIndex,
      objectIDs: objectIDs
    });
  }

  return {
    algoliaAddToCart,
    algoliaProductClickedEvent,
    algoliaProductClickedEventAfterSearch,
    mountAlgoliaInsights
  };
}